export default __webpack_public_path__ + "static/media/iconGrid.b785c89f.svg";